import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {ILocationService, ILogService, IPromise, IRootScopeService, IWindowService} from "angular";
import {StateService, TransitionService, UIRouterGlobals} from "@uirouter/angularjs";
import {DokumentRessurs} from "felles/tjenester/ressurser/DokumentRessurs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import {gettextCatalog} from "angular-gettext";
import {MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {KommentarRessurs} from "felles/tjenester/ressurser/KommentarRessurs";
import {SakRessurs} from "felles/tjenester/ressurser/SakRessurs";
import {ProtokollRessurs} from "felles/tjenester/ressurser/ProtokollRessurs";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {ArkivRessurs} from "felles/tjenester/ressurser/ArkivRessurs";
import {PlanRessurs} from "felles/tjenester/ressurser/PlanRessurs";
import {DashboardFilterKontroller, DashboardFiltervalg} from "../moduler/dashboard/komponenter/dashboardFilter/dashboardFilter";
import _ from "lodash";
import {PersistertValgtSaksgruppeInfo, PlanerKontroller} from "../moduler/dashboard/komponenter/planer/planer";
import {Debugger} from "debug";
import {OppgaveFilterUrlSpesifikasjon} from "../moduler/oppgave/komponenter/oppgaverFilter/oppgaverFilter";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {MenyTjeneste} from "../komponenter/meny/meny";
import {uriDekodet} from "felles/stoettefunk/uri";
import {erIkkeNill} from "felles/stoettefunk/nillsjekk";
import {AjsWebNavigasjon} from "web-ng2/tjenester/ajs/AjsWebNavigasjon";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";
import {MøteKontroller} from "web/moduler/møte/komponenter/møte/møte";

const debug: Debugger = require('debug')('WebNavigasjon');

export class WebNavigasjon implements AjsWebNavigasjon {

    static eventer = {
        navigasjonForhindret: 'webnavigasjon.navigasjonForhindret',
        forhindreNavigasjonAktivert: 'webnavigasjon.forhindreNavigasjonAktivert'
    };

    static regNavn = 'WebNavigasjon';
    private static forespurtSideKey = "forespurtSide";

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            regNavn.ng.ui.$state,
            regNavn.ng.ui.$transitions,
            regNavn.ng.ui.$uiRouterGlobals,
            regNavn.ng.$location,
            regNavn.ng.$window,
            regNavn.ng.$log,
            PlanRessurs.regNavn,
            MøteRessurs.regNavn,
            ProtokollRessurs.regNavn,
            KommentarRessurs.regNavn,
            SakRessurs.regNavn,
            OppgaveRessurs.regNavn,
            ArkivRessurs.regNavn,
            DokumentRessurs.regNavn,
            MenyTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            WebNavigasjon
        ]
    }

    constructor(private $rootScope: IRootScopeService,
                private $state: StateService,
                private $transitions: TransitionService,
                private $uiRouterGlobals: UIRouterGlobals,
                private $location: ILocationService,
                private $window: IWindowService,
                private $log: ILogService,
                private planRes: PlanRessurs,
                private møteRes: MøteRessurs,
                private protokollRes: ProtokollRessurs,
                private kommentarRes: KommentarRessurs,
                private sakRes: SakRessurs,
                private oppgaveRes: OppgaveRessurs,
                private arkivRes: ArkivRessurs,
                private dokumentRes: DokumentRessurs,
                private menyTjeneste: MenyTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
    }

    private avbrytNavLytter: Function;

    //funksjoner for å hindre navigasjon - feks når redigeringsskjemaer er aktive

    deaktiverNavigasjon(): () => void {
        debug('deaktiverNavigasjon, avbrytNavLytter:%s', this.avbrytNavLytter)
        if (this.navigasjonDeaktivert()) return;
        this.$rootScope.$broadcast(WebNavigasjon.eventer.forhindreNavigasjonAktivert, true);
        this.menyTjeneste.deaktiverMenyer();
        this.avbrytNavLytter = this.$transitions.onBefore({}, trans => this.avbrytNavigasjon(trans));
        return () => this.reaktiverNavigasjon();
    }

    reaktiverNavigasjon() {
        debug('reaktiverNavigasjon')
        this.$rootScope.$broadcast(WebNavigasjon.eventer.forhindreNavigasjonAktivert, false);
        this.menyTjeneste.aktiverMenyer();
        if (this.navigasjonDeaktivert()) this.avbrytNavLytter();
        this.avbrytNavLytter = null;
    }

    navigasjonDeaktivert() {
        return !_.isNil(this.avbrytNavLytter);
    }

    private avbrytNavigasjon(trans: Transition): boolean {
        debug('avbrytNavigasjon', trans)
        if (trans.to().name == 'forside.logginn') return true; //ikke avbryt om navigasjon skjer pga utlogging
        this.$rootScope.$broadcast(WebNavigasjon.eventer.navigasjonForhindret, trans);
        return false; //false avbryter navigasjonen
    }

    //navigasjon

    gåTilForsiden() {
        return this.$state.go("forside.lederplan");
    }

    gåTilAdministrasjonSøk() {
        return this.$state.go('innhold.administrasjonSøk');
    }

    gåTilAdministrasjonAvtaler() {
        return this.$state.go('innhold.administrasjonAvtaler');
    }

    gåTilAdministrasjonBrukere() {
        return this.$state.go('innhold.administrasjonBrukere');
    }

    gåTilAdministrasjonMeldinger() {
        return this.$state.go('innhold.administrasjonMeldinger');
    }

    gåTilAdministrasjonAsynkOppgaver() {
        return this.$state.go('innhold.administrasjonAsynkOppgaver');
    }

    gåTilAdministrasjonSpørreskjemaer() {
        return this.$state.go('innhold.administrasjonSpørreskjemaer');
    }

    gåTilRegistrerGruppeOgBruker() {
        return this.$state.go("forside.opprettGruppe");
    }

    gåTilRegistrerGruppeOgBrukerSteg2() {
        return this.$state.go("forside.opprettGruppeSteg2");
    }

    gåTilInvitasjonGodtatt() {
        return this.$state.go("forside.invitasjonGodtatt");
    }

    //eksponerer foreløpig ikke 'huskmeg' parameter
    gåTilInnloggingssiden(opprinneligForespurtSti: string = "", relast = false) {
        //ikke gjør noe dersom vi allerede er på innloggingssiden
        if (this.$state.is("forside.logginn")) return;
        sessionStorage.setItem("forespurtSide", opprinneligForespurtSti);
        return this.$state.go("forside.logginn", null, {reload: relast});
    }

    gåTilSti(sti: string) {
        if (_.isEmpty(sti)) this.gåTilStartsiden();
        this.$location.url(sti);
    }

    innloggingssidenUrl() {
        return "/forside/lederplan"
    }

    gåTilBindBrukerOpenId(subjectInfo: l.SubjectIdIkkeKnyttetTilBrukerModell) {
        return this.$state.go("forside.bindbrukercriipto", subjectInfo);
    }

    gåTilBindBrukerOpenIdFeilet() {
        return this.$state.go('forside.openid-bindbruker-feilet')
    }

    startsideUrl() {
        return "/innhold/dashboard"
    }

    gåTilStartsiden() {
        return <IPromise<any>>this.$state.go("innhold.dashboard");
    }

    gåTilPlan() {
        return this.$state.go("innhold.dashboard.plan");
    }

    gåTilPlanMedFiltervalg(filtervalg: DashboardFiltervalg) {
        return this.$state.go('innhold.dashboard.plan', {
              q: DashboardFilterKontroller.serialisertDashboardFiltervalg(filtervalg),
          },
          {reload: false}); //uten reload vil ikke klikk på "gå til tema/sakstype" fungere i saksvisning på plansiden
    }

    gåTilMøteliste() {
        return this.$state.go("innhold.dashboard.moeteliste");
    }

    gåTilÅrshjul() {
        return this.$state.go("innhold.dashboard.aarshjul");
    }

    gåTilListeSakerKnyttetTilTema(sak: l.AgendaelementModell) {
        if (_.isNil(sak.tema)) return;
        return this.gåTilListeSakerKnyttetTil(sak, l.SaksgrupperingPlan.tema, sak.tema.id);
    }

    gåTilListeSakerKnyttetTilSakstype(sak: l.AgendaelementModell) {
        if (_.isNil(sak.sakstype)) return;
        return this.gåTilListeSakerKnyttetTil(sak, l.SaksgrupperingPlan.sakstype, sak.sakstype.id);
    }

    private gåTilListeSakerKnyttetTil(sak: l.AgendaelementModell, gruppering: l.SaksgrupperingPlan, grupperingId: string) {
        return this.planRes.hentEnkel(sak.moete.planId).$promise
          .then(plan => {
              const filtervalg = new DashboardFiltervalg()
              filtervalg.gruppering = gruppering;
              filtervalg.periode = plan.periode;

              const info: PersistertValgtSaksgruppeInfo = {
                  gruppeId: sak.eiendeGruppeId,
                  saksgruppeType: gruppering, //finnes også i filter.gruppering
                  id: grupperingId,
              };

              return this.$state.go('innhold.dashboard.plan', {
                    q: DashboardFilterKontroller.serialisertDashboardFiltervalg(filtervalg),
                    f: PlanerKontroller.serialisertValgtSaksgruppeInfo(info),
                },
                {reload: true}); //uten reload vil ikke klikk på "gå til tema/sakstype" fungere i saksvisning på plansiden
          });
    }

    gåTilOpprettPlan(gruppeId: string = null) {
        const params = {};
        if (!_.isEmpty(gruppeId)) params['gruppeId'] = gruppeId;
        return this.$state.go('innhold.planOpprett', params);
    }

    gåTilOpprettPlanMedPeriodeValgt(gruppeId: string, periode: l.PlanPeriode) {
        const params = {gruppeId: gruppeId, start: periode.start.toISOString(), slutt: periode.slutt.toISOString()};
        return this.$state.go('innhold.planOpprett', params);
    }

    gåTilFørsteTilgjengeligeMøte(): IPromise<void> {
        return this.møteRes.finnFørsteTilgjengeligeMøte(moment().toDate()).$promise
          .then(møte => {
              if (!møte.id) {
                  ///infomelding som vises når bruker klikker på "neste møte" når det ikke finnes noen møter (feks ved ny bruker/gruppe)
                  this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det er ikke registrert noen møter"));
                  return;
              }
              this.gåTilMøte(møte.id)
          });
    }

    gåTilMøte(møteId: string, erstattLokasjon = false) {
        return <IPromise<any>>this.$state.go(
          "innhold.moete",
          {id: møteId},
          erstattLokasjon ? {location: 'replace'} : {}
        );
    }

    gåTilRedigerSaksrekkefølge(møteId: string) {
        return <IPromise<any>>this.$state.go(
          "innhold.moete",
          {id: møteId, redigerRekkefølge: true}
        );
    }

    gåTilMøteOgRelast(møteId: string) {
        return this.$state.go("innhold.moete", {id: møteId}, {reload: 'innhold.moete'}); //bruk reload:'innhold.moete' når vi oppdaterer
    }

    gåTilMøtedeltaker(deltakerId: string, erstattLokasjon = false) {
        return this.møteRes.finnMøteIdTilknyttetDeltaker(deltakerId).$promise
          .then(møteId => this.gåTilMøte(møteId.id, erstattLokasjon));
    }

    gåTilMøteProtokoll(møteId: string, relast = false, erstattLokasjon = false) {
        return this.$state.go(
          "innhold.moete.protokoll",
          {id: møteId, rediger: false},
          erstattLokasjon ? {reload: relast, location: 'replace'} : {reload: relast}
        );
    }

    gåTilRedigerMøteProtokoll(møteId: string, gjenopprettSkjema = false, visGenerertForslag = false) {
        return this.$state.go("innhold.moete.protokoll", {id: møteId, rediger: true, gjenopprettSkjema: gjenopprettSkjema, visGenerertForslag: visGenerertForslag});
    }

    gåTilSignerMøteProtokoll(møteId: string, relast = false) {
        return this.$state.go("innhold.moete.protokoll", {id: møteId, signer: true}, {reload: relast})
          //sørger for å scolle til signaturfelter når vi allerede står på protokoll-arkfanene
          //for da vil ikke MøteprotokollVisKomponent.scrollTilSignering() bli kalt (kalles normalt når komponent opprettes - og derfor ikke når vi allerede står på møteprotokoll-vis)
          .then(() => this.$rootScope.$broadcast(MøteKontroller.eventer.scrollTilSignering));
    }

    gåTilProtokollførtMøtedeltaker(deltakerId: string, erstattLokasjon = false) {
        return this.møteRes.finnMøteIdTilknyttetProtokollførtDeltaker(deltakerId).$promise
          .then(møteId => this.gåTilMøteProtokoll(møteId.id, undefined, erstattLokasjon));
    }

    gåTilMøteProtokollKnyttetTilProtokolldokumentVersjon(dokumentId: string, forespurtAnnoteringId: string, erstattLokasjon = false) {
        return this.protokollRes.finnMøteProtokolldokumentGjelderFor(dokumentId).$promise
          .then(møteId => {
              return this.$state.go(
                "innhold.moete.protokoll",
                {id: møteId.id, dokumentId: dokumentId, forespurtAnnoteringId: forespurtAnnoteringId},
                erstattLokasjon ? {location: 'replace'} : {}
              );
          });
    }

    gåTilMøteAvstemning(møteId: string) {
        return this.$state.go("innhold.moete.avstemning", {id: møteId});
    }

    gåTilMøteEndringshendelser(møteId: string) {
        return this.$state.go("innhold.moete.endringshendelser", {id: møteId});
    }

    gåTilMøteProtokollFraProtokolldokumentISak(dokumentId: string) {
        return this.protokollRes.finnMøteProtokolldokumentISakGjelderFor(dokumentId).$promise.then(møteId => this.gåTilMøteProtokoll(møteId.id));
    }

    gåTilSak2(møteId: string, sakId: string, erstattLokasjon = false) {
        return this.$state.go(
          'innhold.moete.sak',
          {id: møteId, sakId: sakId},
          erstattLokasjon ? {location: 'replace'} : {}
        )
    }

    gåTilBeslutning2(møteId: string, sakId: string, beslutningId: string, erstattLokasjon = false) {
        return this.$state.go(
          'innhold.moete.sak.beslutning',
          {id: møteId, sakId: sakId, beslutningId: beslutningId},
          erstattLokasjon ? {location: 'replace'} : {}
        )
    }

    gåTilSak(sakId: string, erstattLokasjon = false) {
        return this.møteRes.finnMøteIdTilknyttetSak(sakId).$promise.then(møteId => this.gåTilSak2(møteId.id, sakId, erstattLokasjon));
    }

    gåTilSakOgOppgave(møteId: string, sakId: string, oppgaveId: string, erstattLokasjon = false) {
        return this.$state.go(
          'innhold.moete.sak.oppgave',
          {id: møteId, sakId: sakId, oppgaveId: oppgaveId},
          erstattLokasjon ? {location: 'replace'} : {}
        );
    }

    gåTilSakOgDokument(møteId: string, sakId: string, dokumentId: string, erstattLokasjon = false) {
        this.$state.go(
          'innhold.moete.sak.dokument',
          {id: møteId, sakId: sakId, dokumentId: dokumentId},
          erstattLokasjon ? {location: 'replace'} : {}
        );
    }

    gåTilRedigerSak(møteId: string, sakId: string) {
        return this.$state.go('innhold.moete.sak', {id: møteId, sakId: sakId, redigerSak: true})
    }

    gåTilSakEllerArkivKnyttetTilDokument(dokumentId: string, erstattLokasjon = false) {
        return this.dokumentRes.hentGjeldendeDokumentversjon(dokumentId).$promise
          .then(dokument => {
              if (dokument.foreldre.sakId) {
                  this.møteRes.finnMøteIdTilknyttetSak(dokument.foreldre.sakId).$promise
                    .then(møteId =>
                      this.$state.go('innhold.moete.sak.dokument',
                        {
                            id: møteId.id,
                            sakId: dokument.foreldre.sakId,
                            dokumentId: dokument.dokumentId
                        },
                        erstattLokasjon ? {location: 'replace'} : {}
                      ));
              }
              if (dokument.foreldre.arkivfilnodeId) {
                  this.gåTilArkivdokumentKnyttetTilDokument(dokumentId, undefined, true);
              }
          });
    }

    gåTilSakEllerArkivKnyttetTilDokumentVersjon(versjonsId: string, erstattLokasjon = false) {
        return this.dokumentRes.hentDokumentVersjon(versjonsId).$promise
          .then((dokumentVersjon) => this.gåTilSakEllerArkivKnyttetTilDokument(dokumentVersjon.dokumentId, erstattLokasjon));
    }

    gåTilSakKnyttetTilDokumentVersjon(dokumentVersjonId: string, erstattLokasjon = false) {
        return this.dokumentRes.hent(dokumentVersjonId).$promise
          .then(saksdokument =>
            this.møteRes.finnMøteIdTilknyttetSak(saksdokument.foreldre.sakId).$promise
              .then(møteId =>
                this.$state.go(
                  'innhold.moete.sak.dokument',
                  {
                      id: møteId.id,
                      sakId: saksdokument.foreldre.sakId,
                      dokumentId: saksdokument.dokumentId
                  },
                  erstattLokasjon ? {location: 'replace'} : {}
                ))
          );
    }

    gåTilSakKnyttetTilDokumentAnnotering(dokumentAnnoteringId: string) {
        return this.dokumentRes.hentSaksdokumentBasertPåDokumentAnnotering(dokumentAnnoteringId).$promise
          .then(saksdokument =>
            this.møteRes.finnMøteIdTilknyttetSak(saksdokument.foreldre.sakId).$promise
              .then(møteId =>
                this.$state.go('innhold.moete.sak.dokument', {
                    id: møteId.id,
                    sakId: saksdokument.foreldre.sakId,
                    dokumentId: saksdokument.dokumentId,
                    forespurtAnnoteringId: dokumentAnnoteringId
                }))
          );
    }

    gåTilSignerSaksdokument(dokumentId: string, erstattLokasjon = false) {
        return this.dokumentRes.hentGjeldendeDokumentversjon(dokumentId).$promise
          .then(saksdokument =>
            this.møteRes.finnMøteIdTilknyttetSak(saksdokument.foreldre.sakId).$promise
              .then(møteId =>
                this.$state.go('innhold.moete.sak.dokument.signer',
                  {
                      id: møteId.id,
                      sakId: saksdokument.foreldre.sakId,
                      dokumentId: saksdokument.dokumentId
                  },
                  erstattLokasjon ? {location: 'replace'} : {}
                ))
          );
    }

    gåTilDokumentKnyttetTilDokumentAnnotering(dokumentAnnoteringId: string, erstattLokasjon = false) {
        return this.dokumentRes.hentDokumentversjonBasertPåDokumentAnnotering(dokumentAnnoteringId).$promise
          .then((dokumentversjon: l.DokumentVersjonModell) => {
                switch (dokumentversjon.type) {
                    case l.DokumentType.arkivdokument:
                        return this.gåTilArkivdokumentKnyttetTilDokumentVersjon(dokumentversjon.id, true, erstattLokasjon); //relast=true ellers skjer ingen ting dersom søket gjøres når man står i arkivmodulen
                    case l.DokumentType.opplastetSaksdokument:
                    case l.DokumentType.generertAgendaDokument:
                    case l.DokumentType.arkivdokumentISak:
                    case l.DokumentType.protokolldokumentISak:
                        return this.gåTilSakKnyttetTilDokumentVersjon(dokumentversjon.id, erstattLokasjon);
                    case l.DokumentType.protokolldokument:
                        return this.gåTilMøteProtokollKnyttetTilProtokolldokumentVersjon(dokumentversjon.dokumentId, dokumentAnnoteringId, erstattLokasjon);
                    case l.DokumentType.generiskDokument:
                    default:
                        const melding = `gåTilDokumentKnyttetTilDokumentAnnotering(): ikke-håndtert dokumenttype ${dokumentversjon.type}, dokumentAnnoteringId:${dokumentAnnoteringId}`;
                        this.$log.warn(melding);
                        throw new Error(melding)
                }
            }
          );
    }

    gåTilAvstemning(avstemningId: string, sakId?: string, møteId?: string, erstattLokasjon = false): IPromise<any> {
        if (sakId === undefined) return this.møteRes.finnMøteOgSakIdTilknyttetAvstemning(avstemningId).$promise
          .then(møteOgSakId => this.gåTilAvstemning(avstemningId, møteOgSakId.sakId, møteOgSakId.moeteId, erstattLokasjon));
        return <IPromise<any>>this.$state.go(
          'innhold.moete.sak.avstemning',
          {
              id: møteId,
              sakId: sakId,
              avstemningId: avstemningId
          },
          erstattLokasjon ? {location: 'replace'} : {}
        );
    }

    gåTilBeslutning(beslutningId: string, erstattLokasjon = false) {
        return this.møteRes.finnMøteOgSakIdTilknyttetBeslutning(beslutningId).$promise.then(møteOgSakId => this.gåTilBeslutning2(møteOgSakId.moeteId, møteOgSakId.sakId, beslutningId, erstattLokasjon));
    }

    gåTilOppgave(oppgave: string | l.OppgaveModell, erstattLokasjon = false) {
        if (erStreng(oppgave))
            return this.oppgaveRes.hent(oppgave).$promise
              .then(oppgave =>
                this.gåTilOppgaveFraModell(oppgave, erstattLokasjon))

        this.gåTilOppgaveFraModell(oppgave, erstattLokasjon);
    }

    private gåTilOppgaveFraModell(oppgave: l.OppgaveModell, erstattLokasjon = false) {
        if (!oppgave.harForelder) {
            const spek: OppgaveFilterUrlSpesifikasjon = {
                grupper: [oppgave.eiendeGruppeId],
                statuser: [],
                ansvarlige: [],
                ansvarligUtvalg: 'valgte',
                sortering: {retning: l.Sortering.synkende, kolonne: l.Oppgavesorteringskolonne.frist},
            };
            if (oppgave.ansvarlig) spek.ansvarlige.push(oppgave.ansvarlig.epost);
            if (oppgave.utfoert) spek.statuser.push(l.OppgavestatusKriterie.utfoert)
            else if (oppgave.frist == null) spek.statuser.push(l.OppgavestatusKriterie.uten_frist)
            else if (moment(oppgave.frist).isBefore()) spek.statuser.push(l.OppgavestatusKriterie.ikke_forfalt)
            return this.gåTilOppgaveliste(spek, erstattLokasjon);
        }
        switch (oppgave.forelderRef.type.toLowerCase()) {
          // AgendaelementId vil returnere agendaelement her.
            case 'agendaelement':
            case 'sak':
                const sakId = oppgave.forelderRef.id;
                return this.møteRes.finnMøteIdTilknyttetSak(sakId).$promise
                  .then(møteId => this.gåTilSakOgOppgave(møteId.id, sakId, oppgave.id, erstattLokasjon));
            case 'beslutning':
                return this.gåTilBeslutning(oppgave.forelderRef.id, erstattLokasjon);
            default:
                debug(`håndtering av forelderRef ${oppgave.forelderRef.type}:${oppgave.forelderRef.id} ikke implementert`);
                return this.$state.go("innhold.oppgaver");
        }
    }

    gåTilOppgaveliste(spek: OppgaveFilterUrlSpesifikasjon, erstattLokasjon = false) {
        return this.$state.go("innhold.oppgaver", {q: angular.toJson(spek)}, erstattLokasjon ? {location: 'replace'} : {});
    }

    gåTilKommentarsForelder(kommentarId: string, erstattLokasjon = false) {
        return this.kommentarRes.hent(kommentarId).$promise
          .then(kommentar => this.gåTilEntitetRef(kommentar.forelder.entitetRef, erstattLokasjon));
    }

    gåTilMedlem(gruppeId: string, medlemId: string) {
        return this.$state.go("innhold.gruppe.medlem", {gruppeId: gruppeId, medlemId: medlemId});
    }

    gåTilEntitetRef(entitetRef: l.EntitetReferanseModell, erstattLokasjon = false): IPromise<any> {
        debug('gåTilEntitetRef', entitetRef);
        switch (entitetRef.type.toLowerCase()) {
            case 'sak':
                return this.gåTilSak(entitetRef.id, erstattLokasjon);

            case 'avstemning':
                return this.gåTilAvstemning(entitetRef.id, undefined, undefined, erstattLokasjon);

            case 'beslutning':
                return this.gåTilBeslutning(entitetRef.id, erstattLokasjon);

            case 'oppgave':
                return this.gåTilOppgave(entitetRef.id, erstattLokasjon);

            case 'møte':
                return this.gåTilMøte(entitetRef.id, erstattLokasjon);

            case 'møtedeltaker':
                return this.gåTilMøtedeltaker(entitetRef.id, erstattLokasjon);

            case 'protokollførtmøtedeltaker':
                return this.gåTilProtokollførtMøtedeltaker(entitetRef.id, erstattLokasjon);

            case 'kommentar':
                return this.gåTilKommentarsForelder(entitetRef.id, erstattLokasjon);

            case 'svar':
                return this.gåTilKommentarsForelder(entitetRef.id, erstattLokasjon);

            case 'dokument': //merk at dette vil feile dersom dokumentet er av typen arkivdokument
                return this.gåTilSakEllerArkivKnyttetTilDokument(entitetRef.id, erstattLokasjon);

            case 'opplastetdokumentversjon':
                return this.gåTilSakEllerArkivKnyttetTilDokumentVersjon(entitetRef.id, erstattLokasjon);

            case 'dokumentannotering':
                return this.gåTilDokumentKnyttetTilDokumentAnnotering(entitetRef.id, erstattLokasjon);

            default:
                debug('ingen navigeringshåndtering registrert for', entitetRef);
                return this.gåTilStartsiden();
        }
    }

    gåTilAvtale(avtaleId: string) {
        return this.$state.go("innhold.avtale", {avtaleId: avtaleId});
    }

    gåTilRedigerFaktureringsinformasjon(avtaleId: string) {
        return this.$state.go("innhold.avtale", {avtaleId: avtaleId, redigerFaktureringsinformasjon: true});
    }

    gåTilBrukereIAvtale(avtaleId: string) {
        return this.$state.go("innhold.avtale.brukere", {avtaleId: avtaleId});
    }

    gåTilAksepterteBetingelser(avtaleId: string) {
        return this.$state.go("innhold.avtale.aksepterteBetingelser", {avtaleId: avtaleId});
    }

    gåTilAvtaleAdministrasjon(avtaleId: string) {
        return this.$state.go("innhold.avtale.administrasjon", {avtaleId: avtaleId});
    }

    gåTilGrupper() {
        return this.$state.go("innhold.gruppeoversikt");
    }

    gåTilAvtaler() {
        return this.$state.go("innhold.avtaleoversikt");
    }

    gåTilBruker() {
        return this.$state.go("innhold.gruppeoversikt");
    }

    gåTilBrukerSikkerhetsinnstillinger() {
        return this.$state.go("innhold.brukerSikkerhetsinnstillinger");
    }

    gåTilBrukerMeldingsinnstillinger() {
        return this.$state.go("innhold.brukerMeldingsinnstillinger");
    }

    gåTilGruppe(gruppeId: string, relast = false) {
        return this.$state.go('innhold.gruppe', {gruppeId: gruppeId}, {reload: relast});
    }

    gåTilGruppePlaner(gruppeId: string) {
        return this.$state.go('innhold.gruppe.planer', {gruppeId: gruppeId});
    }

    gåTilGruppeAksjeeierbok(gruppeId: string) {
        return this.$state.go('innhold.gruppe.aksjeeierbok', {gruppeId: gruppeId});
    }

    gåTilGruppeStatistikk(gruppeId: string) {
        return this.$state.go('innhold.gruppe.statistikk', {gruppeId: gruppeId});
    }

    gåTilGruppeKonfigurasjon(gruppeId: string) {
        return this.$state.go('innhold.gruppe.konfigurasjon', {gruppeId: gruppeId});
    }

    gåTilGruppeEndringshendelser(gruppeId: string) {
        return this.$state.go('innhold.gruppe.endringshendelser', {gruppeId: gruppeId});
    }

    gåTilGruppeMøtemal(gruppeId: string, relast = false) {
        return this.$state.go('innhold.gruppe.moetemal', {gruppeId: gruppeId, rediger: false}, {reload: relast});
    }

    gåTilGruppeMøtemalRediger(gruppeId: string) {
        return this.$state.go('innhold.gruppe.moetemal', {gruppeId: gruppeId, rediger: true});
    }

    gåTilGruppeAdministrasjon(gruppeId: string) {
        return this.$state.go('innhold.gruppe.administrasjon', {gruppeId: gruppeId});
    }

    gåTilGruppeSikkerhetsinnstillinger(gruppeId: string) {
        return this.$state.go('innhold.gruppe.sikkerhetsinnstillinger', {gruppeId: gruppeId});
    }

    gåTilGrupperBrukerMal(gruppeId: string) {
        return this.$state.go('innhold.gruppe.grupperBrukerMal', {gruppeId: gruppeId});
    }

    gåTilArkivRot() {
        return this.$state.go('innhold.arkiv');
    }

    gåTilArkiv(mappeId: string) {
        return this.$state.go('innhold.arkiv.mappe', {id: mappeId});
    }

    gåTilArkivdokument(mappeId: string, dokumentId: string, relast = false, erstattLokasjon = false) {
        return this.$state.go('innhold.arkiv.dokument', {id: mappeId, dokumentId: dokumentId});
    }

    gåTilArkivdokumentKnyttetTilDokument(dokumentId: string, relast = false, erstattLokasjon = false) {
        debug('gåTilArkivdokumentKnyttetTilDokument', dokumentId)
        return this.arkivRes.lastFilTilknyttetDokumentId(dokumentId).$promise
          .then(arkivFil =>
            this.$state.go('innhold.arkiv.dokument',
              {
                  id: arkivFil.forelder.id,
                  dokumentId: arkivFil.dokument.dokumentId
              },
              erstattLokasjon ? {reload: relast, location: 'replace'} : {reload: relast}
            ));
    }

    gåTilArkivdokumentKnyttetTilDokumentVersjon(versjonId: string, relast = false, erstattLokasjon = false) {
        return this.arkivRes.lastFilTilknyttetDokumentVersjonId(versjonId).$promise
          .then(arkivFil =>
            this.$state.go(
              'innhold.arkiv.dokument',
              {id: arkivFil.forelder.id, dokumentId: arkivFil.dokument.dokumentId},
              erstattLokasjon ? {reload: relast, location: 'replace'} : {reload: relast}
            ));
    }

    gåTilSignerArkivdokument(dokumentId: string, erstattLokasjon = false) {
        return this.arkivRes.lastFilTilknyttetDokumentId(dokumentId).$promise
          .then(arkivFil =>
            this.$state.go('innhold.arkiv.dokument.signer',
              {
                  id: arkivFil.forelder.id,
                  dokumentId: arkivFil.dokument.dokumentId
              },
              erstattLokasjon ? {location: 'replace'} : {}
            ));
    }

    registrerEventueltForespurtSide() {
        this.angiForespurtSide(this.$uiRouterGlobals.params[WebNavigasjon.forespurtSideKey]);
    }

    angiForespurtSide(forespurtSide: string) {
        if (erIkkeNill(forespurtSide)) {
            sessionStorage.setItem(WebNavigasjon.forespurtSideKey, forespurtSide);
        }
    }

    /**
     * Tar brukeren til en eventuelt forespurt side (eller startsiden), og fjerner forespørselen
     */
    gåTilForespurtEllerStartsiden() {
        const sti = uriDekodet(sessionStorage.getItem(WebNavigasjon.forespurtSideKey));
        sessionStorage.removeItem(WebNavigasjon.forespurtSideKey);
        this.gåTilSti(sti);
    }

    harForespurtSide() {
        return erIkkeNill(sessionStorage.getItem(WebNavigasjon.forespurtSideKey));
    }

    gåTilAksjeeierbok() {
        this.$state.go('innhold.aksjeeierbok');
    }

    gåTilAksjeeier(id: string) {
        this.$state.go('innhold.aksjeeierbok.aksjeeier', {id: id});
    }

    /*
     visSakKnyttetTilBeslutning(beslutningId:string) {
     this.sakRes.finnSaksIdKnyttetTilBeslutning(
     beslutningId,
     (sakId:EntitetIdRespons) => this.$state.go("tabs.sak", {id: sakId.id})
     );
     }

     gåTilKommentarsForelder(kommentarId:string) {
     this.kommentarRes.hent(
     kommentarId,
     kommentar => this.gåTilEntitetRef(kommentar.forelder.entitetRef));
     }

     gåTilGruppeoversikt() {
     this.$state.go("tabs.grupperoversikt");
     }


     */
}

export enum WebModulnavn {dashboard, møte, oppgave, kommentar, gruppe, beslutninger, arkiv, administrasjon, plan}
